import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, AlertTriangle } from 'lucide-react';

const NotificationPopup = ({ notification, onClose }) => {
    const navigate = useNavigate();

    const handleNavigateToServices = () => {
        const first = notification?.services?.[0];
        if (
            notification?.type === 'completion_otp_escalation' &&
            first?.id &&
            first?.case_id
        ) {
            navigate(`/add-service?case_id=${first.case_id}&service_id=${first.id}`);
        } else if (notification?.type === 'customer_payment_failed' && notification?.serviceId) {
            const params = new URLSearchParams({ service_id: String(notification.serviceId) });
            if (notification.caseId) params.set('case_id', String(notification.caseId));
            navigate(notification.caseId ? `/add-service?${params.toString()}` : '/services');
        } else if (notification?.type === 'sla_breach') {
            if (notification?.serviceId && notification?.caseId) {
                navigate(`/add-service?case_id=${notification.caseId}&service_id=${notification.serviceId}`);
            } else {
                navigate('/dashboard');
            }
        } else {
            navigate('/services');
        }
        onClose();
    };

    if (!notification) return null;

    const title =
        notification.type === 'customer_payment_failed'
            ? 'Customer payment failed'
            : notification.type === 'sla_breach'
              ? notification.title || 'SLA breach'
              : notification.title || 'Service Alert';
    const ctaLabel =
        notification.type === 'completion_otp_escalation'
            ? 'Open Service'
            : notification.type === 'sla_breach'
              ? 'Open dashboard'
              : 'View Services';

    return (
        <div className="fixed top-4 right-4 z-50 max-w-sm w-full">
            <div className="bg-white border border-red-200 rounded-lg shadow-lg p-4 animate-slide-in">
                <div className="flex items-start">
                    <div className="flex-shrink-0">
                        <AlertTriangle className="h-6 w-6 text-red-500" />
                    </div>
                    <div className="ml-3 flex-1">
                        <h3 className="text-sm font-medium text-gray-900">
                            {title}
                        </h3>
                        <p className="mt-1 text-sm text-gray-600">
                            {notification.message}
                        </p>
                        <div className="mt-3 flex space-x-2">
                            <button
                                onClick={handleNavigateToServices}
                                className="bg-red-600 text-white px-3 py-1.5 text-xs font-medium rounded hover:bg-red-700 transition-colors"
                            >
                                {ctaLabel}
                            </button>
                            <button
                                onClick={onClose}
                                className="bg-gray-200 text-gray-700 px-3 py-1.5 text-xs font-medium rounded hover:bg-gray-300 transition-colors"
                            >
                                Dismiss
                            </button>
                        </div>
                    </div>
                    <div className="ml-4 flex-shrink-0">
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-600 transition-colors"
                        >
                            <X className="h-4 w-4" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotificationPopup;
